export default "__VITE_ASSET__ZsLMAZHB__"